import { Injectable, EventEmitter } from '@angular/core';
import { Response } from '@angular/http';
import { HttpService } from './http.service';
import { ClResultado } from '../utils/dtos/clResultado';
import { environment } from '../../environments/environment';
import { LoginService } from './login.service';
import { clDatosToken } from '../utils/dtos/clDatosToken';
import { ClDatosConsumidor, AlergiasConsumidor, HorariosConsumidor, AltaPendienteRegistro,
   estudiosConsumidor, datosChat, Bonificacion } from '../utils/dtos/clDatosConsumidor';


@Injectable()
export class UsuarioService {

  apiRest: String;
  idUsuario: number;
  textoBoton: string;
  popupVisible: Boolean;
  usuarioLoad: EventEmitter<boolean>;
  usuarioActivo: Boolean;
  habilitarPopUpContacto: boolean;
  datosConsumidor: ClDatosConsumidor;
  listaAlergias: AlergiasConsumidor[] = [];
  listaEstudios: estudiosConsumidor[] = [];
  listaHistoricos: estudiosConsumidor[] = [];
  listaFidelidad:estudiosConsumidor[]=[];
  habilitarPopUpContra: Boolean;
  listaHorarios: HorariosConsumidor[] = [];
  altaPendiente: AltaPendienteRegistro;
  passwordConsumidor: string;
  textoChat: string;
  datosChat: datosChat = new datosChat();
  listaChats: datosChat[] = [];
  listaChatsPendientes: datosChat[] = [];
  listaConsumidoresBuscador: datosChat[] = [];
  mensajesChat: any[] = [];
  nombreConsumidorChat: string;
  backgroundSeleccionado: string;
  constructor(private httpService: HttpService, private loginService: LoginService) {

  }

  asignarUrl() {
    if (this.loginService.getDesdeDentro()) {
  //    this.apiRest = environment.webApiBaseDesdeDentro;
    } else {
  //    this.apiRest = environment.webApiBaseDesdeFuera;
    }
    this.apiRest = environment.webApiBaseDesdePortal;
  }


  obtenerGruposFuncionales(): Promise<any[]> {
    this.asignarUrl();
    const obj = this;
    return this.httpService.get(this.apiRest + '/ObtenerGruposFuncionales', true).then(function (response) {
        return obj.httpService.extractData(response);
    });
  }
  obtenerDatosUsuario(): Promise<ClDatosConsumidor> {
    this.asignarUrl();
    const obj = this;
    return this.httpService.get(this.apiRest + 'ObtenerInfoConsumidor', true).then(function (response) {
        return obj.httpService.extractDataValues(response);
    });
  }

  obtenerNacionalidades(): Promise<string[]> {
    this.asignarUrl();
    const obj = this;
    return this.httpService.get(this.apiRest + 'ObtenerNacionalidades', true).then(function (response) {
        return obj.httpService.extractDataValues(response);
    });
  }
  obtenerNivelEstudios(): Promise<string[]> {
    this.asignarUrl();
    const obj = this;
    return this.httpService.get(this.apiRest + 'ObtenerNivelEstudios', true).then(function (response) {
        return obj.httpService.extractDataValues(response);
    });
  }
  obtenerEstablecimientoCompra(): Promise<string[]> {
    this.asignarUrl();
    const obj = this;
    return this.httpService.get(this.apiRest + 'ObtenerEstablecimientosDeCompra', true).then(function (response) {
        return obj.httpService.extractDataValues(response);
    });
  }
  obtenerProvincias(): Promise<string[]> {
    this.asignarUrl();
    const obj = this;
    return this.httpService.get(this.apiRest + 'ObtenerProvincias', true).then(function (response) {
        return obj.httpService.extractDataValues(response);
    });
  }
  obtenerAlergias(): Promise<AlergiasConsumidor[]> {
    this.asignarUrl();
    const obj = this;
    return this.httpService.get(this.apiRest + 'ObtenerAlergias', true).then(function (response) {
        return obj.httpService.extractDataValues(response);
    });
  }
  obtenerResponsableCompra(): Promise<string[]> {
    this.asignarUrl();
    const obj = this;
    return this.httpService.get(this.apiRest + 'ObtenerResponsableDeLaCompra', true).then(function (response) {
        return obj.httpService.extractDataValues(response);
    });
  }

  ObtenerProfesiones(): Promise<string[]> {
    this.asignarUrl();
    const obj = this;
    return this.httpService.get(this.apiRest + 'ObtenerProfesiones', true).then(function (response) {
        return obj.httpService.extractDataValues(response);
    });
  }



  obtenerPorcentajes(): Promise<any[]> {
    this.asignarUrl();
    const obj = this;
    return this.httpService.get(this.apiRest + 'ObtenerProductosPorcentajes', true).then(function (response) {
        return obj.httpService.extractDataValues(response);
    });
  }
  obtenerPersonasConviven(): Promise<any[]> {
    this.asignarUrl();
    const obj = this;
    return this.httpService.get(this.apiRest + 'ObtenerPersonasConviven', true).then(function (response) {
        return obj.httpService.extractDataValues(response);
    });
  }
  obtenerComoNosHasConocido(): Promise<string[]> {
    this.asignarUrl();
    const obj = this;
    return this.httpService.get(this.apiRest + 'ObtenerComoNosHasConocido', true).then(function (response) {
        return obj.httpService.extractDataValues(response);
    });
  }
  obtenerIngresosFamiliares(): Promise<string[]> {
    this.asignarUrl();
    const obj = this;
    return this.httpService.get(this.apiRest + 'ObtenerIngresosFamiliares', true).then(function (response) {
        return obj.httpService.extractDataValues(response);
    });
  }
  obtenerHorarios(): Promise<HorariosConsumidor[]> {
    this.asignarUrl();
    const obj = this;
    return this.httpService.get(this.apiRest + 'ObtenerHorariosDisponibles', true).then(function (response) {
        return obj.httpService.extractDataValues(response);
    });
  }

  ObtenerEstudioDetalle(valor, valor1): Promise<ClResultado> {
    this.asignarUrl();
    const obj = this;
    return this.httpService.get(this.apiRest + 'ObtenerEstudioDetalle?ContadorEstudio=' + valor + '&ContadorConsumidor=' +
    valor1, true).then(function (response) {
        return obj.httpService.extractDataValues(response);
    });
  }

  mostrarSegment(): Promise<ClResultado> {
    this.asignarUrl();
    const obj = this;
    return this.httpService.get(this.apiRest + 'MostrarSegmentFidelidad', true).then(function (response) {
        return obj.httpService.extractDataValues(response);
    });
  }

  getBonificacion(id): Promise<Bonificacion> {
    this.asignarUrl();
    const obj = this;
    return this.httpService.get(this.apiRest + 'ObtenerDatosGratificacion?Id='+id, true).then(function (response) {
        return obj.httpService.extractDataValues(response);
    });
  }
  obtenerEncuestas(): Promise<any> {
    this.asignarUrl();
    const obj = this;
    return this.httpService.get(this.apiRest + 'ObtenerEncuestas', true).then(function (response) {
        return obj.httpService.extractDataValues(response);
    });
  }


  /////// gestion del alta del consumidor //////
  AltaPendienteRegistro(): Promise<ClResultado> {
    this.asignarUrl();
    const obj = this;
    const jsonData = '{"InfoConsumidor":' + JSON.stringify(this.altaPendiente) + '}';
    return this.httpService.post(this.apiRest + 'AltaPendienteRegistro', jsonData, true).then(function (response) {
        return obj.httpService.extractDataValues(response);
    });
  }
  MofificarDatosConsumidor(): Promise<ClResultado> {
    this.asignarUrl();
    const obj = this;
    const jsonData = '{"DatosConsumidor":' + JSON.stringify(this.datosConsumidor) + '}';

    return this.httpService.post(this.apiRest + 'AltaPendienteRegistro', jsonData, true).then(function (response) {
        return obj.httpService.extractDataValues(response);
    });
  }
  validarEmail(codigo): Promise<ClResultado> {
    this.asignarUrl();
    const obj = this;
    return this.httpService.get(this.apiRest + 'ValidarEmail?Codigo=' + codigo, true).then(function (response) {
        return obj.httpService.extractDataValues(response);
    });
  }
  refrescarEmail(codigo) {
    this.asignarUrl();
    const obj = this;
    return this.httpService.get(this.apiRest + 'PonerEmailPendiente?Codigo=' + codigo, true).then(function (response) {
        return obj.httpService.extractDataValues(response);
    });
  }

  /////// alta del consumidor ///////////
  AltaConsumidor(): Promise<ClResultado> {
    this.asignarUrl();
    const obj = this;
    const jsonData = '{"InfoConsumidor":' + JSON.stringify(this.datosConsumidor) + '}';
    return this.httpService.post(this.apiRest + 'AltaConsumidor', jsonData, true).then(function (response) {
        return obj.httpService.extractDataValues(response);
    });
  }
  ModificarConsumidor(): Promise<ClResultado> {
    this.asignarUrl();
    const obj = this;
    const jsonData = '{"InfoConsumidor":' + JSON.stringify(this.datosConsumidor) + '}';
    return this.httpService.post(this.apiRest + 'ModificarConsumidor', jsonData, true).then(function (response) {
        return obj.httpService.extractDataValues(response);
    });
  }

  //// obtener los estudios
  obtenerEstudios(tipo): Promise<estudiosConsumidor[]> {
    this.asignarUrl();
    const obj = this;
    return this.httpService.get(this.apiRest + 'ObtenerEstudios?Tipo=' + tipo, true).then(function (response) {
        return obj.httpService.extractDataValues(response);
    });
  }

  //// gestion de las contraseñas /////
  cambiarContrasenya(pass: string): Promise<ClResultado> {
    this.asignarUrl();
    const obj = this;
    return this.httpService.get(this.apiRest + 'CambiarContrasenaDentro?Pass=' + pass, true).then(function(response) {
      return obj.httpService.extractDataValues(response);
    });
  }
  recordarContrasenya1(user: string): Promise<ClResultado> {
    this.asignarUrl();
    const obj = this;
    return this.httpService.get(this.apiRest + 'CambiarContrasenaFuera_1?Usu=' + user, true).then(function(response) {
      return obj.httpService.extractDataValues(response);
    });
  }
  recordarContrasenya2(user: string): Promise<ClResultado> {
    this.asignarUrl();
    const obj = this;
    return this.httpService.get(this.apiRest + 'CambiarContrasenaFuera_2?Pass=' + user, true).then(function(response) {
      return obj.httpService.extractDataValues(response);
    });
  }
  recordarContrasenya3(codigo: string): Promise<ClResultado> {
    this.asignarUrl();
    const obj = this;
    return this.httpService.get(this.apiRest + 'CambiarContrasenaFuera_3?Codigo=' + codigo, true).then(function(response) {
      return obj.httpService.extractDataValues(response);
    });
  }

  /// inscripcion a estudios
  ObtenerMensajeEstudio(valor): Promise<ClResultado> {
    this.asignarUrl();
    const obj = this;
    return this.httpService.get(this.apiRest + 'ObtenerMensajeEstudio?ContadorEstudio=' + valor, true).then(function (response) {
        return obj.httpService.extractDataValues(response);
    });
  }

  ActualizarInscripcionAEstudio(valor): Promise<ClResultado> {
    this.asignarUrl();
    const obj = this;
    return this.httpService.get(this.apiRest + 'ActualizarInscripcionAEstudio?Clave=' + valor + '&TipoInscripcion=WEB',
      true).then(function (response) {
          return obj.httpService.extractDataValues(response);
    });
  }
  ponerEnReserva(contador, sesion):Promise<ClResultado> {
    this.asignarUrl();
    const obj = this;
    return this.httpService.get(this.apiRest + 'PonerEnReserva?ContadorEstudio=' + contador + '&Sesion=' + sesion,
      true).then(function (response) {
          return obj.httpService.extractDataValues(response);
    });
  }
  // llamadas al chat
  altaChat(datos) {
    this.asignarUrl();
    const obj = this;
    const jsonData = '{"InfoConversacionChat":' + JSON.stringify(datos) + '}';
    return this.httpService.post(this.apiRest + 'AltaConversacionChat', jsonData, true).then(function (response) {
        return obj.httpService.extractDataValues(response);
    });
  }
  recogerUltimosChats(): Promise<datosChat[]> {
    this.asignarUrl();
    const obj = this;
    return this.httpService.get(this.apiRest + 'ObtenerUlitmosChats', true).then(function(response) {
      return obj.httpService.extractDataValues(response);
    });
  }
  busquedasChat(texto: string): Promise<datosChat[]> {
    this.asignarUrl();
    const obj = this;
    return this.httpService.get(this.apiRest + 'BuscarConsumidorChat?TextoBusqueda=' + texto, true).then(function(response) {
      return obj.httpService.extractDataValues(response);
    });
  }
  ObtenerTokenConsumidores(contador): Promise<clDatosToken> {
    this.asignarUrl();
    const obj = this;
    return this.httpService.get(this.apiRest + 'ObtenerTokenConsumidorDesdeAinia?ContadorConsumidor='
    + contador, true).then(function (response) {
        return obj.httpService.extractDataValues(response);
    });
  }
  ObtenerTokenAinia(user: string, pass: string): Promise<clDatosToken> {
    this.asignarUrl();
    const obj = this;
    return this.httpService.get(this.apiRest + 'ObtenerToken?usuario='
    + user + '&pass=' + pass, true).then(function (response) {
        return obj.httpService.extractDataValues(response);
    });
  }

  pruebaWebHook(parametro): Promise<ClResultado> {
    this.asignarUrl();
    const obj = this;
    return this.httpService.get(this.apiRest + 'PruebaWebHook?survey_id='
    + parametro, true).then(function (response) {
        return obj.httpService.extractDataValues(response);
    });
  }
  darseDeBaja(tipo): Promise<ClResultado> {
    this.asignarUrl();
    const obj = this;
    return this.httpService.get(this.apiRest + 'SolicitarBaja?TipoBaja=' + tipo, true).then(function (response) {
        return obj.httpService.extractDataValues(response);
    });
  }
  previoBaja(codigo): Promise<ClResultado> {
    this.asignarUrl();
    const obj = this;
    return this.httpService.get(this.apiRest + 'PrevioBaja?Codigo=' + codigo, true).then(function (response) {
        return obj.httpService.extractDataValues(response);
    });
  }
  inscribirseOnline(clave, TipoInscripcion): Promise<ClResultado> {
    this.asignarUrl();
    const obj = this;
    return this.httpService.get(this.apiRest + 'ActualizarInscripcionAEstudio?Clave=' + clave +
    '&TipoInscripcion=' + TipoInscripcion, true).then(function (response) {
        return obj.httpService.extractDataValues(response);
    });
  }
  ObtenerEstadoBaja(): Promise<ClResultado> {
    this.asignarUrl();
    const obj = this;
    return this.httpService.get(this.apiRest + 'ObtenerEstadoBaja', true).then(function (response) {
        return obj.httpService.extractDataValues(response);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/usuario.service.ts